class CnrProductGridSelector {
  constructor() {
    document.querySelectorAll(".cnr-product-grid-selector").forEach(selector=>{
      this.render(selector);
      selector.addEventListener("click",event=>{
        Array.from(document.querySelectorAll(".cnr-product-grid-selector.active"))
          .filter(otra=>otra.dataset.productId!=selector.dataset.productId)
          .forEach(otra=>otra.classList.remove("active"));
        
        selector.classList.toggle("active");

        this.fixPosition(selector);
        window.setTimeout(()=>{
         // this.fixPosition(selector)
        
        },5);
        
      });
      selector.addEventListener("gridselector-close-all",event=>{
        console.error("closing 2");
        selector.classList.remove("active");
      });
      selector.querySelectorAll(".option-item").forEach(item=>item.addEventListener("click",event=>{
        event.stopPropagation();
        event.preventDefault();
        let compareAt;

        if (item.dataset.compare){
          compareAt  = item.dataset.compare;
        }

        selector.querySelector(".header .desktop").textContent = item.dataset.title;

        if (selector.parentNode.parentNode.querySelector(".grid-sale-prices")){
          if (compareAt){
            selector.parentNode.parentNode.querySelector(".grid-sale-prices").innerHTML = `<div class="h5">${item.dataset.price}</div><s class="h5">${compareAt}</s>`;
          }
          else {
            selector.parentNode.parentNode.querySelector(".grid-sale-prices").innerHTML = `<div class="h5">${item.dataset.price}</div>`;
          }
        }
        if (selector.parentNode.parentNode.querySelector(".product-grid-price")){
          if (compareAt){
            selector.parentNode.parentNode.querySelector(".product-grid-price").innerHTML = `<div class="h5">${item.dataset.price}</div><s class="h5">${compareAt}</s>`;
          }
          else {
            selector.parentNode.parentNode.querySelector(".product-grid-price").innerHTML = `<div class="h5">${item.dataset.price}</div>`;
          }
        }

        selector.querySelector(".header .mobile").textContent = item.dataset.title.split("(")[0];
        selector.querySelector(".header .desktop").textContent = item.dataset.title.split("(")[0];
        selector.querySelector(".cnr-product-grid-variant-id").value = item.dataset.variantId;
        selector.classList.remove("active")
      }))
    });
    
    document.querySelector("body").addEventListener("click",event=>{
      let node = event.target;
      let proceed= true;
      while(proceed && node.parentNode) {
        if (node.classList.contains("cnr-product-grid-selector")) {
          proceed = false;
        } else if (node.classList.contains("main-content")) {
          proceed = false;
          console.error("closing");
          document.querySelectorAll(".cnr-product-grid-selector").forEach(selector=>selector.classList.remove("active"))
          
        } else {
          node = node.parentNode;
        }
      }
    })
  }
  fixPosition(selector) {
    let left = 0;
    let options = selector.querySelector(".options");
    let rect = options.getBoundingClientRect();
    if (rect.width<1) {
       return; 
    }
    let parentRect = options.parentNode.parentNode.getBoundingClientRect(); 
    console.error([rect,parentRect]);
    if (rect.x+rect.width>window.innerWidth) {
      left = (window.innerWidth - (rect.x+rect.y))/3;
      options.style.right='-20px';
    } else {
      options.style.left="revert";
      
    }
    //options.style.left = `${left}px`;  
  }
  setTitle(item) {
    selector.querySelector(".header").textContent = item.dataset.title;
  }
  render(selector) {
  }
}